export const getProcessedValue = (value: string) => {
  let processedValue = value
    // Replace <b> tags with <strong>
    .replace(/<b\b([^>]*)>/gi, '<strong$1>')
    .replace(/<\/b>/gi, '</strong>');
  // Replace \n with <br>
  // .replace(/\n/g, '<br>');

  // Process any tags with font-weight: bold
  processedValue = processedValue.replace(
    /<(\w+)\s+style="[^"]*font-weight:\s*bold[^"]*">(.*?)<\/\1>/gi,
    (match, tagName, content) => {
      // If style contains only font-weight: bold, replace entire tag with strong
      if (
        match.match(/style="[^"]*font-weight:\s*bold[^"]*"/) &&
        !match.match(/style="[^"]*font-weight:\s*bold[^"]*[^;][^"]*"/)
      ) {
        return `<strong>${content}</strong>`;
      }

      // If there are other styles, keep the tag and add strong inside
      return match.replace('>', '><strong>').replace(`</${tagName}>`, `</strong></${tagName}>`);
    },
  );

  return processedValue;
};
